var exports = {
  "kL": "GuildDiscoveryTab.module__container___a25pRC",
  "wx": "GuildDiscoveryTab.module__header___a25pRC",
  "DD": "GuildDiscoveryTab.module__title___a25pRC",
  "VA": "GuildDiscoveryTab.module__subtitle___a25pRC",
  "dc": "GuildDiscoveryTab.module__spinnerContainer___a25pRC",
  "vz": "GuildDiscoveryTab.module__statusCard___a25pRC",
  "jf": "GuildDiscoveryTab.module__statusRow___a25pRC",
  "Rh": "GuildDiscoveryTab.module__statusLabel___a25pRC",
  "Od": "GuildDiscoveryTab.module__statusBadge___a25pRC",
  "Wp": "GuildDiscoveryTab.module__statusPending___a25pRC",
  "Oe": "GuildDiscoveryTab.module__statusApproved___a25pRC",
  "rP": "GuildDiscoveryTab.module__statusRejected___a25pRC",
  "Zs": "GuildDiscoveryTab.module__statusRemoved___a25pRC",
  "d2": "GuildDiscoveryTab.module__reviewReason___a25pRC",
  "Zi": "GuildDiscoveryTab.module__formCard___a25pRC",
  "bk": "GuildDiscoveryTab.module__fieldLabel___a25pRC",
  "BK": "GuildDiscoveryTab.module__helpText___a25pRC",
  "o1": "GuildDiscoveryTab.module__actions___a25pRC",
  "$e": "GuildDiscoveryTab.module__warning___a25pRC",
  "au": "GuildDiscoveryTab.module__warningContent___a25pRC",
  "QW": "GuildDiscoveryTab.module__warningIcon___a25pRC",
  "r2": "GuildDiscoveryTab.module__warningBody___a25pRC",
  "tJ": "GuildDiscoveryTab.module__warningTitle___a25pRC",
  "i4": "GuildDiscoveryTab.module__warningText___a25pRC",
  "pq": "GuildDiscoveryTab.module__info___a25pRC",
  "QI": "GuildDiscoveryTab.module__infoContent___a25pRC",
  "G": "GuildDiscoveryTab.module__infoIcon___a25pRC",
  "aV": "GuildDiscoveryTab.module__infoText___a25pRC",
  "Uz": "GuildDiscoveryTab.module__tagsField___a25pRC",
  "Cs": "GuildDiscoveryTab.module__tagsList___a25pRC",
  "r3": "GuildDiscoveryTab.module__tagChip___a25pRC",
  "Xp": "GuildDiscoveryTab.module__tagChipRemove___a25pRC",
  "C_": "GuildDiscoveryTab.module__tagsInputRow___a25pRC",
};

module.exports = exports;
